import { LogoutDto } from '../../../dto/logout/logoutdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface LogoutRequest extends APIRequest
{
    getLogoutRequest(): LogoutDto;
}

export class LogoutRequestImpl extends APIRequestDtoImpl implements LogoutRequest
{
    constructor(private logoutData: LogoutDto)
    {
        super();
    }

    getLogoutRequest(): LogoutDto
    {
        return this.logoutData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/logout/logoutrequest.tsx